// This is a simple in-memory counter for demo purposes
// In a real app, you'd want to persist this in localStorage or get it from the server
let mrnCounter = 1000; // Start from 1000 or any other number you prefer

/**
 * Generates a sequential MRN (Medical Record Number)
 * Format: MRN-{incrementalNumber}
 */
export const generateMRN = (): string => {
  const mrn = `MRN-${mrnCounter.toString().padStart(6, '0')}`;
  mrnCounter += 1;
  
  // Save to localStorage to persist between page refreshes
  if (typeof window !== 'undefined') {
    localStorage.setItem('mrnCounter', mrnCounter.toString());
  }
  
  return mrn;
};

// Initialize counter from localStorage if available
if (typeof window !== 'undefined') {
  const savedCounter = localStorage.getItem('mrnCounter');
  if (savedCounter) {
    mrnCounter = parseInt(savedCounter, 10) || 1000;
  }
}
